import { chakra, Link } from '@chakra-ui/react'
import { StartupscomLogoSvg } from '@src/components/sco/StartupscomLogoSvg'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import { NextLink } from '@src/components/sco/utilities/NextLink'
import * as React from 'react'

export const StartupscomLogo = (props: {
  href?: string
  onClick?: () => void
  size?: string
  logoSize?: { width?: number; height?: number }
}) => {
  const { getBreakpointValue } = useBreakpointContext()
  const isMobile = props.size == 'sm' || getBreakpointValue({ base: true, lg: false })

  return (
    <Link asChild>
      <NextLink
        href={props.href || '/'}
        onClick={() => {
          if (props.onClick) {
            props.onClick()
          }
        }}
      >
        <chakra.span display={'inline-flex'}>
          <StartupscomLogoSvg
            height={props.logoSize?.height || (isMobile ? 36 : 40)}
            width={props.logoSize?.width || (isMobile ? 126 : 140)}
          />
        </chakra.span>
      </NextLink>
    </Link>
  )
}
